import { Review } from './review';

export class ReviewCalc extends Review {
    // calc values
    review_total: number;
    balance: number;
    nok: number;
    ok: number;

    // not used
    brand_sigle: string;
    model_code: string;

    constructor(partial: Partial<any>) {
        super(partial);

        this.review_total = partial.review_total || 0;
        this.balance = partial.balance || 0;
        this.nok = partial.nok || 0;
        this.ok = partial.ok || 0;

        this.brand_sigle = partial.brand_sigle;
        this.model_code = partial.model_code;
    }

    validate = (): boolean => this.review_percentage > -1 && this.order_count > -1;

    calculateReview(): number {
        if (!this.order_count || !this.review_percentage) return 0;

        const multi =  this.order_count * this.review_percentage;
        const result = Math.round(multi / 100);

        this.review_total = result

        return result;
    }

    calculateReviewBalance(): number {
        if (!this.calculateReview()) return 0;

        const sub = this.calculateReview() - this.reviewed;

        this.balance = sub;

        return sub;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/review-calc.model.ts